import { Link } from "react-router-dom";
import { CalendarDays, Martini, Phone, Instagram } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/translations";
import { Reveal, Sparkles, PerBadge } from "../components/ui-bits";
import { Marquee } from "../components/Marquee";

const ThemeFridayInfo = () => {
  const { t } = useLanguage();

  return (
    <Reveal delay={0.35}>
      <div className="mt-12 glass rounded-3xl p-8 max-w-2xl mx-auto text-center" data-testid="friday-theme-info">
        <h3 className="font-display text-2xl uppercase tracking-widest neon">{t("jenever.themeTitle")}</h3>
        <p className="text-sm text-[#9db8d6] mt-3 leading-relaxed max-w-md mx-auto">{t("jenever.themeText")}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <a href="tel:+3214812093" data-testid="friday-theme-call" className="btn-neon text-xs font-display tracking-[0.15em] uppercase px-6 py-2.5 rounded-full inline-flex items-center gap-2">
            <Phone size={14} /> {t("jenever.themeCall")}
          </a>
          <a href="https://www.instagram.com/bowlinghelios" target="_blank" rel="noreferrer" data-testid="friday-theme-insta" className="btn-ghost text-xs font-display tracking-[0.15em] uppercase px-6 py-2.5 rounded-full inline-flex items-center gap-2">
            <Instagram size={14} /> {t("jenever.themeInsta")}
          </a>
        </div>
      </div>
    </Reveal>
  );
};

export default function Jenever() {
  const { t } = useLanguage();
  return (
    <main className="theme-violet">
      <section className="relative min-h-screen flex items-center overflow-hidden grain" data-testid="jenever-section">
        <div className="absolute inset-0">
          <img src={IMAGES.jeneverImg} alt="Jenever Discobowling" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#05070B]/85 via-[#05070B]/60 to-[#05070B]" />
        </div>
        <div className="light-beam left-[10%]" />
        <div className="light-beam right-[12%]" style={{ animationDelay: "-4s" }} />
        <Sparkles count={20} />
        <div className="hidden lg:block disco-ball absolute top-28 right-[10%] w-36 h-36 rounded-full" />

        <div className="relative max-w-5xl mx-auto px-5 text-center py-32">
          <Reveal>
            <p className="font-display text-sm tracking-[0.5em] uppercase text-[#F0C971] mb-6 flex items-center justify-center gap-2">
              <Martini size={16} /> {t("jenever.sub")}
            </p>
            <h1 className="font-disco text-[9vw] sm:text-6xl lg:text-8xl neon-strong neon-flicker leading-tight" data-testid="jenever-title">
              {t("jenever.title")}
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 text-lg text-[#E2F1FF] leading-relaxed max-w-2xl mx-auto">{t("jenever.text")}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 inline-flex flex-col items-center gap-3 glass rounded-3xl px-14 py-8" data-testid="jenever-price">
              <span className="font-disco text-6xl gold-text">{t("jenever.price")}</span>
              <PerBadge>{t("prices.perPerson")} / {t("prices.perGame")}</PerBadge>
            </div>
          </Reveal>
          <Reveal delay={0.28}>
            <p className="mt-8 text-sm text-[#9db8d6] flex items-center justify-center gap-2 max-w-xl mx-auto" data-testid="jenever-schedule-note">
              <CalendarDays size={16} className="text-[#00F0FF] shrink-0" /> {t("jenever.note")}
            </p>
            <div className="mt-10">
              <Link to="/reserveer" data-testid="jenever-reserve-cta" className="btn-neon font-display text-xl tracking-[0.25em] uppercase px-14 py-5 rounded-full">
                {t("jenever.cta")}
              </Link>
            </div>
          </Reveal>
          <ThemeFridayInfo />
        </div>
      </section>
      <Marquee />
    </main>
  );
}
